import { __assign } from "tslib";
import { CallCenterAgentStatus } from './callcenter-agent-status.enum';
import { AgentBuilder } from '../agent/agent.builder';
var CallCenterAgentBuilder = /** @class */ (function () {
    function CallCenterAgentBuilder() {
        var baseAgent = new AgentBuilder().build();
        this.callCenterAgent = __assign(__assign({}, baseAgent), { callCenter: true, callCenterId: 'd0dd0d0d-d0d0-d0d0-d0d0-d0dd0dd0dd0d', queueIds: [], activeCallId: 'c0cc0c0c-c0c0-c0c0-c0c0-c0cc0cc0cc0c', statistics: {
                avgCallDurationSec: 60,
                callsCount: 1,
                lastUpdateDate: Date.now() - 1000,
                totalTimeBusySec: 30,
                timesBusy: 1
            }, activity: {
                status: CallCenterAgentStatus.ONLINE,
                statusStartDate: Date.now() - 3600,
                customStatusId: 'a0aa0a0a-a0a0-a0a0-a0a0-a0aa0aa0aa0a',
            }, callCenterStatus: CallCenterAgentStatus.ONLINE });
    }
    CallCenterAgentBuilder.prototype.withUserId = function (id) {
        this.callCenterAgent.id = id;
        return this;
    };
    CallCenterAgentBuilder.prototype.withFirstName = function (firstName) {
        this.callCenterAgent.firstName = firstName;
        if (!this.callCenterAgent.fullName) {
            this.callCenterAgent.fullName = firstName;
        }
        return this;
    };
    CallCenterAgentBuilder.prototype.withLastName = function (lastName) {
        this.callCenterAgent.lastName = lastName;
        return this;
    };
    CallCenterAgentBuilder.prototype.withFullName = function (fullName) {
        this.callCenterAgent.fullName = fullName;
        return this;
    };
    CallCenterAgentBuilder.prototype.withProfileImage = function (profileImage) {
        this.callCenterAgent.profileImage = profileImage;
        return this;
    };
    CallCenterAgentBuilder.prototype.withLocation = function (site) {
        this.callCenterAgent.location = site;
        return this;
    };
    CallCenterAgentBuilder.prototype.withStatus = function (status) {
        this.callCenterAgent.callCenterStatus = status;
        this.callCenterAgent.activity.status = status;
        return this;
    };
    CallCenterAgentBuilder.prototype.withActiveCallId = function (activeCallId) {
        this.callCenterAgent.activeCallId = activeCallId;
        return this;
    };
    CallCenterAgentBuilder.prototype.withCustomStatusId = function (customStatusId) {
        this.callCenterAgent.activity.customStatusId = customStatusId;
        return this;
    };
    CallCenterAgentBuilder.prototype.withStatusStartDate = function (statusStartDate) {
        this.callCenterAgent.activity.statusStartDate = statusStartDate;
        return this;
    };
    CallCenterAgentBuilder.prototype.withAvgCallDurationSec = function (avgCallDurationSec) {
        this.callCenterAgent.statistics.avgCallDurationSec = avgCallDurationSec;
        return this;
    };
    CallCenterAgentBuilder.prototype.withCallsCount = function (callsCount) {
        this.callCenterAgent.statistics.callsCount = callsCount;
        return this;
    };
    CallCenterAgentBuilder.prototype.withShiftStartDate = function (shiftStartDate) {
        this.callCenterAgent.statistics.lastUpdateDate = shiftStartDate;
        return this;
    };
    CallCenterAgentBuilder.prototype.withTotalTimeBusySec = function (totalTimeBusySec) {
        this.callCenterAgent.statistics.totalTimeBusySec = totalTimeBusySec;
        return this;
    };
    CallCenterAgentBuilder.prototype.withTimesBusy = function (timesBusy) {
        this.callCenterAgent.statistics.timesBusy = timesBusy;
        return this;
    };
    CallCenterAgentBuilder.prototype.withQueueIds = function (ids) {
        this.callCenterAgent.queueIds = ids;
        return this;
    };
    CallCenterAgentBuilder.prototype.withGroupIds = function (ids) {
        this.callCenterAgent.groupIds = ids;
        return this;
    };
    CallCenterAgentBuilder.prototype.withRoleId = function (roleId) {
        this.callCenterAgent.roleId = roleId;
        return this;
    };
    CallCenterAgentBuilder.prototype.build = function () {
        return this.callCenterAgent;
    };
    return CallCenterAgentBuilder;
}());
export { CallCenterAgentBuilder };
//# sourceMappingURL=callcenter-agent.builder.js.map